<script>
export default {
	inheritAttrs: false
};
</script>

<script setup>
import { computed, ref, watchEffect } from "vue";

const props = defineProps(["class", "style", "innerClass", "innerStyle", "error", "label", "tooltip", "modelValue"]);

const emit = defineEmits(["update:modelValue"]);

const checkbox = ref(null);

const checkedValue = computed({
	get() {
		if (props.modelValue === 0)
			return false;
		else if (props.modelValue === 1)
			return true;

		return props.modelValue;
	},
	set(value) {
		emit("update:modelValue", value);
	}
});

watchEffect(() => {
	if (checkbox.value)
		checkbox.value.setCustomValidity(typeof props.error !== "undefined" ? props.error : "");
});
</script>

<template>
	<label :class="class" :style="style" class="vui-checkbox">
		<input
			ref="checkbox"
			v-model="checkedValue"
			:class="innerClass"
			:style="innerStyle"
			v-bind="$attrs"
			type="checkbox"
		>
		<div class="label">
			<slot>{{ label }}</slot>
		</div>
		<span v-if="$attrs.required || $attrs.required === ''" class="badge">{{ $gettext("required") }}</span>
		<i v-if="tooltip" class="fa-solid fa-square-info tooltip" @click.prevent><div class="tooltip-content">{{ tooltip }}</div></i>
	</label>
</template>
